import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import rp from 'request-promise-native'
import InputMask from 'react-input-mask'

import { uriV2 } from '../../services/defaultProps'
import Interface from '../../components/Interface'

import detectBrowserLanguage from 'detect-browser-language'
import WhatsAppShopDoubt from '../../components/WhatsAppShopDoubt'
import { unmaskString } from '../../services/ShopHelpers'

import Loader from 'react-loader-spinner'
import { FiEdit3 } from 'react-icons/fi'

const renderLoading = () => {
  return (
    <div style={{ position: 'absolute', top: 100, left: '50%', transform: 'translate(-50%, 0)' }}>
      <Loader
        type='TailSpin'
        color='#6d357b'
        height='50'
        width='50'
      />
    </div>
  )
}

class PayerInfo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      email: (this.props.payerInfo && this.props.payerInfo.email) || this.props.user.email || '',
      name: (this.props.payerInfo && this.props.payerInfo.name) || this.props.user.name || '',
      phone: (this.props.payerInfo && this.props.payerInfo.phoneNumber) || this.props.user.phone || '',
      emailError: false,
      nameError: false,
      phoneError: false,
      language: 1
    }
  }

  componentWillMount () {
    if (!localStorage.getItem('language')) {
      if (detectBrowserLanguage() === 'pt-BR' || detectBrowserLanguage() === 'pt-PT' || detectBrowserLanguage() === 'pt' || detectBrowserLanguage().slice(0, 2) === 'pt') {
        this.setState({ language: 0 })
        localStorage.setItem('language', '0')
      }
      if (detectBrowserLanguage().slice(0, 2) === 'es') {
        this.setState({ language: 2 })
        localStorage.setItem('language', '2')
      }
    } else {
      this.setState({ language: localStorage.getItem('language') - '0' })
    }
    this.setState({isLoading: false})
  }

  handleContinueButton = async () => {
    if (!this.state.email) {
      this.setState({emailError: true})
      return
    }

    if (!this.state.name) {
      this.setState({nameError: true})
      return
    }

    if (!this.state.phone || this.state.phone.length < 10) {
      this.setState({phoneError: true})
      return
    }

    this.setState({isLoading: true})

    await rp({
      uri: `${uriV2}/shop/payer`,
      method: 'POST',
      headers: {
        Authorization: this.props.token
      },
      body: {
        email: this.state.email,
        name: this.state.name,
        phoneNumber: this.state.phone
      },
      json: true
    }).then((response) => {
      this.props.setPayerInfo({ payerInfo: response })
    })
      .finally(() => {
        this.setState({isLoading: false})
      })

    // go to next page

    if (this.props.location.state && this.props.location.state.serviceBilling) {
      if (!this.props.card || this.props.card.length === 0) {
        return this.props.history.push('/dados-cobranca/cartao/adicionar', {
          serviceBilling: this.props.location.state.serviceBilling
        })
      }

      return this.props.history.push('/cobrancas/finalizar-compra', {
        serviceBilling: this.props.location.state.serviceBilling
      })
    }

    if (!this.props.deliveryAddress) {
      return this.props.history.push('/dados-entrega')
    }
    if (!this.props.card || this.props.card.length === 0) {
      return this.props.history.push('/dados-cobranca/cartao/adicionar')
    }
    return this.props.history.push('/finalizar-compra')
  }

  renderContent = () => {
    return (
      <div style={{display: 'flex', flexDirection: 'column', height: 'calc(100vh - 50px)', width: '100%'}}>
        <h2 className='shop-description-header'>Complete seus dados de cobrança:</h2>
        <div style={{width: '90%', textAlign: 'center', maxWidth: '720px', marginLeft: 'auto', marginRight: 'auto', padding: 8}}>
          <div>
            <div className='shop-input-header-div'>
              <h3 className={this.state.emailError ? 'shop-input-header-error' : 'shop-input-header'}>E-mail</h3>
            </div>
            <div>
              <input type='text' className={this.state.emailError ? 'input-text-error' : 'input-text'}
                onChange={(e) => this.setState({email: e.target.value, emailError: false})}
                value={this.state.email}
                onKeyPress={this.handleKeyPress}
              />
            </div>
          </div>
          <div>
            <div className='shop-input-header-div'>
              <h3 className={this.state.nameError ? 'shop-input-header-error' : 'shop-input-header'}>Nome</h3>
            </div>

            <div>
              <input type='text' className={this.state.nameError ? 'input-text-error' : 'input-text'}
                onChange={(e) => this.setState({name: e.target.value, nameError: false})}
                value={this.state.name}
                onKeyPress={this.handleKeyPress}
              />
            </div>
          </div>
          <div>
            <div className='shop-input-header-div'>
              <h3 className={this.state.phoneError ? 'shop-input-header-error' : 'shop-input-header'}>Telefone</h3>
            </div>

            <div>
              <InputMask type='text' className={this.state.phoneError ? 'input-text-error' : 'input-text'}
                onChange={(e) => this.setState({phone: unmaskString(e.target.value), phoneError: false})}
                value={this.state.phone}
                onKeyPress={this.handleKeyPress}
                mask='(99) 99999-9999'
                maskChar={null}
              />
            </div>
          </div>
        </div>
        <div style={{backgroundColor: 'rgba(148, 66, 138, 0.5)', height: '1px', width: '90%', margin: 'auto', marginTop: 16, marginBottom: 16}} />
        <WhatsAppShopDoubt clientName={this.props.user.name} />
        <div onClick={this.handleContinueButton} style={{marginTop: 'auto', width: '100%'}}>
          <div id='purchase' style={{whiteSpace: 'pre-wrap'}}>
              Continuar
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <Interface
        title='Dados de cobrança'
        history={this.props.history}
        showFooter={false}
        backgroundClass='shop-background'
        logoIcon={
          <FiEdit3 size='20'
            color='#94428a'
          />
        }
        customPadding={8}
      >
        {
          this.state.isLoading ? renderLoading() : this.renderContent()}
      </Interface>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer,
    ...state.productsReducer,
    payerInfo: state.productsReducer.payerInfo
  }
}

export default connect(mapStateToProps, actions)(PayerInfo)



// WEBPACK FOOTER //
// ./src/containers/Shop/PayerInfo.js